/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { State } from 'app/main/store';
import * as fromTenants from 'app/page-modules/tenant-management/store/tenant-management.selectors';
import { filterUndefined } from 'app/shared/rxjs/rxjs.utils';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'app/user-auth/services/auth.service';
import { TenantDetails, AuditRequestReason } from 'app/page-modules/tenant-management/models';
import { AuditedLoginToTenant, LoginToTenant } from 'app/user-auth/store/user-auth.actions';
import { TenantLoginReasonPanelComponent } from 'app/shared/components/tenant-login-reason-panel/tenant-login-reason-panel.component';

@Component({
  selector: 'og-tenant-login',
  templateUrl: './tenant-login.component.html',
  styleUrls: ['./tenant-login.component.scss'],
  standalone: false
})
export class TenantLoginComponent implements OnInit, OnDestroy {
  private subscription: Subscription;

  constructor(
    private store: Store<State>,
    private authService: AuthService,
    private route: ActivatedRoute,
    private matDialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.subscription = this.store
      .pipe(select(fromTenants.getSelectedTenantData), filterUndefined())
      .subscribe(tenant => setTimeout(() => this.loginToTenant(tenant)));
  }

  private loginToTenant(tenantDetails: TenantDetails): void {
    const previewEnvironment = this.route.snapshot.params.preview;
    if (this.authService.requiresLoginReason(tenantDetails)) {
      const ref = this.matDialog.open(TenantLoginReasonPanelComponent);
      ref.componentInstance.saveClick.subscribe((auditDetails: AuditRequestReason) => {
        this.store.dispatch(
          new AuditedLoginToTenant(tenantDetails, previewEnvironment, auditDetails)
        );
        ref.close();
      });
    } else {
      this.store.dispatch(new LoginToTenant(tenantDetails, previewEnvironment));
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
